import Context from "./Context";

export default class LanguageValueObj {
  constructor() {
    this.map = new Map();
    this.value="@value";
    this.lang="@language";
    this.context=new Context();
  }

  addLang(lang) {
    this.map.set(lang, "");
  }

  removeLang(lang) {
    if (this.map.has(lang)) {
      this.map.delete(lang);
    }
  }

  setValue(lang, value) {
    this.map.set(lang, value);
  }

  /* getValue(lang) {
    return this.map.has(lang)?this.map.get(lang):"";
  } */

  getValue(lang, fallbackLang = "en") {
    const value = this.map.get(lang);

    if (value && value.trim() !== "") {
      return value;
    }

    // fallback
    const fallbackValue = this.map.get(fallbackLang);
    if (fallbackValue && fallbackValue.trim() !== "") {
      return fallbackValue;
    }

    return "";
  }

  containsLang(lang) {
    return this.map.has(lang);
  }

  getContext() {
    return this.context;
  }

  getExpandedFormatValue() {
    const list2return=[];
    for (const [lang, value] of this.map) {
      list2return.push({[this.lang]: lang, [this.value]: value});
    }
    return list2return;
  }

  parseInputJSON(inputJSON, objKey) {
    const obj=inputJSON[objKey];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        this.setValue(value[this.lang], value[this.value]);
      }
    } else {
      this.setValue(obj[this.lang], obj[this.value]);
    }
  }

  parseJsonObj(jsonObj) {
    this.setValue(jsonObj[this.lang], jsonObj[this.value]);
  }

  isEmpty(specificLang) {
    let condition=true;
    for (const [lang, value] of this.map) {
      if (specificLang&&specificLang===lang) {
        condition=condition&&!value;
      } else {
        condition=condition&&!value;
      }
    }
    return condition;
  }

  clear(lang) {
    if (lang) {
      this.map.delete(lang); // Clears the value for a specific language
    } else {
      this.map.clear(); // Clears the entire map
    }
  }

  print() {
    for (const [key, value] of this.map.entries()) {
      console.log(key+" : "+value);
    }
  }
}
